var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 182.534,
    viewBox: "0 0 100 182.534",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #002c5f;\r\n        fill-rule: evenodd;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10158",
    "data-name": "Path 10158",
    className: "cls-1",
    d: "M113.133,5.24H37.823A12.38,12.38,0,0,0,25.479,17.584V175.429a12.38,12.38,0,0,0,12.344,12.344h75.309a12.382,12.382,0,0,0,12.346-12.344V17.584A12.383,12.383,0,0,0,113.133,5.24ZM75.478,177.158a7.705,7.705,0,1,1,7.705-7.705A7.72,7.72,0,0,1,75.478,177.158Zm31.058-23.288H44.42V21.312h62.117V153.871Z",
    transform: "translate(-25.479 -5.24)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.acf403739c838070a446d9b750bd4a65.svg";
export { ForwardRef as ReactComponent };